import { HbrCancel } from "../MyCustomsvgicons";

const AlertDialog= ({buttonName, closeDialog, dialogMessage, showActionBtn, callAction}) => {
    return ( 
    <div className="alert-messages flex-column2">
        <div className="flex-spacebetween" style={{width:"100%"}}>
            {showActionBtn && <button onClick={()=>callAction()}>{buttonName}</button>}
            <HbrCancel width={"2em"} height={"2em"} fillColour={"white"} handleClick={()=>closeDialog()}/>
        </div>

        <p style={{fontWeight:"bold", color:"white"}}>{dialogMessage}</p>
    </div> 
    );
}
export default AlertDialog;